import styled from 'styled-components'

export const StyledBiddingAnnoucement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 73px 34px 42px 34px;

  b,
  p {
    text-align: center;
  }

  b {
    font-size: 24px;
    font-weight: 500;
    margin-top: 20px;
    margin-bottom: 10px;
    padding-inline: 10%;
  }
`

export const StyledBiddingAnnoucementImage = styled.div`
  position: relative;

  img {
    &:first-child {
      width: 287px;
      height: auto;
    }

    &:last-child {
      position: absolute;
      width: 64px;
      height: 64px;
      top: -32px;
      right: -32px;
    }
  }
`
